import { LinearProgress, linearProgressClasses } from '@mui/material';
import { styled } from '@mui/system';
import COLORS from '../../../theme/Colors';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent:'center',
  width:'100%',
  height:'100%',
  backgroundColor:COLORS.white,
});


export const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: '0.5em',
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: COLORS.lightGray
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: COLORS.tertiary,
  },
}));

export const AnimationContainer = styled('div')({
  display: 'flex',
  alignSelf: 'center',
  alignItems: 'center',
  '@media (min-width:320px)': {
    width: '180px',
  },
  '@media (min-width:768px)': {
    width: '600px',
  },
})
